module.exports = __webpack_public_path__ + "img/arrow-bridge-purple.e47f0686.svg";